/* toki-sponsored-wheel.part2.js — isolated Grit Goo UI */
(function(){
  'use strict';
  var W=window.TokiSponsoredWheelEngine, U=W&&W.util;
  if(!W||!U||W.__part2Loaded) return;
  W.__part2Loaded=true;

  W.buildUI=function(inst){
    var r=inst.refs, host=inst.host;
    host.innerHTML='';
    host.classList.add('ggw-root');

    r.shell=U.el('section',{class:'ggw-shell','aria-label':'Grit Goo character wheel'});
    r.fx=U.el('div',{class:'ggw-fx','aria-hidden':'true'},[
      U.el('div',{class:'ggw-fx__ring ggw-fx__ring--1'}),
      U.el('div',{class:'ggw-fx__ring ggw-fx__ring--2'}),
      U.el('div',{class:'ggw-fx__sparks'})
    ]);
    r.stage=U.el('div',{class:'ggw-stage'});
    r.wheelWrap=U.el('div',{class:'ggw-wheelWrap'});
    r.svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
    r.svg.setAttribute('class','ggw-wheelSvg');
    r.svg.setAttribute('viewBox','0 0 1000 1000');
    r.svg.setAttribute('role','img');
    r.svg.setAttribute('aria-label','Spin the Grit Goo character wheel');
    r.hit=U.el('button',{class:'ggw-hit',type:'button','aria-label':'Spin the Grit Goo wheel'});
    r.pointer=U.el('div',{class:'ggw-pointer','aria-hidden':'true'},[U.el('span',{class:'ggw-pointer__tooth'})]);
    r.wheelWrap.appendChild(r.svg);
    r.wheelWrap.appendChild(r.hit);
    r.wheelWrap.appendChild(r.pointer);
    r.stage.appendChild(r.wheelWrap);

    r.spin=U.el('button',{class:'ggw-spin',type:'button'},[
      U.el('span',{class:'ggw-spin__small',text:'ENTER THE CHAOS'}),
      U.el('span',{class:'ggw-spin__big',text:'SPIN THE GOO'})
    ]);
    r.status=U.el('div',{class:'ggw-status','aria-live':'polite',text:'Tap the wheel or smash the button.'});
    r.stage.appendChild(r.spin);
    r.stage.appendChild(r.status);

    r.confetti=U.el('canvas',{class:'ggw-confetti',hidden:'','aria-hidden':'true'});
    r.modalBack=U.el('div',{class:'ggw-modalBack',hidden:''});
    r.modal=U.el('div',{class:'ggw-modal',role:'dialog','aria-modal':'true','aria-label':'Grit Goo wheel result'});
    r.modalBack.appendChild(r.modal);

    r.shell.appendChild(r.fx);
    r.shell.appendChild(r.stage);
    host.appendChild(r.shell);
    document.body.appendChild(r.confetti);
    document.body.appendChild(r.modalBack);
  };
})();
